import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../../utils/util';

import './user-metrics-pie-chart.scss';

const UserMetricsPieChart = ({ title, outerRingData, innerRingData, previousValue, currentValue, color }) => {
  let innerRingColor;
  let outerRingColor;

  if (color === 'pink') {
    innerRingColor = '#9D6391';
    outerRingColor = '#F99DE7';
  } else if (color === 'purple') {
    innerRingColor = '#614F94';
    outerRingColor = '#A385F6';
  } else if (color === 'blue') {
    innerRingColor = '#6D96AB';
    outerRingColor = '#9DDAF9';
  }

  let increaseValue = ((currentValue - previousValue) / previousValue) * 100;
  if (increaseValue < 0) {
    increaseValue = increaseValue * -1;
  }

  return (
    <section className="user-metrics-pie-chart">
      <h3 className="user-metrics-pie-chart__header">{title}</h3>
      <section className="user-metrics-pie-chart__container">
        <PieChart width={250} height={250}>
          <Pie
            data={innerRingData}
            dataKey="value"
            innerRadius={70}
            outerRadius={85}
            startAngle={90}
            endAngle={450}
            isAnimationActive={false}
          >
            {innerRingData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={['#EDEDED', innerRingColor][index]} />
            ))}
          </Pie>
          <Pie
            data={outerRingData}
            dataKey="value"
            innerRadius={90}
            outerRadius={105}
            startAngle={90}
            endAngle={450}
            isAnimationActive={false}
          >
            {outerRingData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={['#EDEDED', outerRingColor][index]} />
            ))}
          </Pie>
        </PieChart>
        <section className="user-metrics-pie-chart__values">
          <div
            className={getClassNames('user-metrics-pie-chart__value', {
              pink: color === 'pink',
              purple: color === 'purple',
              blue: color === 'blue',
            })}
          >
            <p>Previous:</p>
            <p>{previousValue}</p>
          </div>
          <div
            className={getClassNames('user-metrics-pie-chart__value', {
              pink: color === 'pink',
              purple: color === 'purple',
              blue: color === 'blue',
            })}
          >
            <p>Current:</p>
            <p>{currentValue}</p>
          </div>
          {isFinite(increaseValue) && (
            <div
              className={getClassNames('user-metrics-pie-chart__value', {
                pink: color === 'pink',
                purple: color === 'purple',
                blue: color === 'blue',
              })}
            >
              <p>{currentValue >= previousValue ? 'Increase' : 'Decrease'}:</p>
              <p>{increaseValue.toFixed(0)}%</p>
            </div>
          )}
        </section>
      </section>
    </section>
  );
};

UserMetricsPieChart.propTypes = {
  title: PropTypes.string.isRequired,
  outerRingData: PropTypes.arrayOf(PropTypes.object).isRequired,
  innerRingData: PropTypes.arrayOf(PropTypes.object).isRequired,
  previousValue: PropTypes.number.isRequired,
  currentValue: PropTypes.number.isRequired,
  increaseValue: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

export default UserMetricsPieChart;
